// extracted by mini-css-extract-plugin
module.exports = {"root":"AddressCell_root__2oIZl","button":"AddressCell_button__3ENLi","camerasCount":"AddressCell_camerasCount__24vKb"};